import Vue from 'vue';

// include reset and utility classes
import '@/base/global-css/_classes.scss';

// js utilities that need direct access to the DOM
import '@/base/global-js/AnalyticsEvents';
import '@/base/global-js/GoToTop';
import '@/base/global-js/LanguageSwitcher';
import '@/base/global-js/LazyLoader';
import '@/base/global-js/LinkMimic';
import '@/base/global-js/ResizeListener';
import '@/base/global-js/Tooltip';
import '@/base/global-js/TogglePanel';
import '@/base/global-js/Utilities';

// Component dependencies

// base
import CloButton from '@/base/CloButton/CloButton.vue';
Vue.component('CloButton', CloButton);

import CloHeading from '@/base/CloHeading/CloHeading.vue';
Vue.component('CloHeading', CloHeading);

import CloPage from '@/base/CloPage/CloPage.vue';
Vue.component('CloPage', CloPage);

import CloSkipTo from '@/base/CloSkipTo/CloSkipTo.vue';
Vue.component('CloSkipTo', CloSkipTo);

// forms
import CloSuggest from '@/forms/CloSuggest/CloSuggest.vue';
Vue.component('CloSuggest', CloSuggest);

// grid
import CloGridFlex from '@/grid/CloGridFlex/CloGridFlex.vue';
Vue.component('CloGridFlex', CloGridFlex);

// icons
import CloIcon from '@/icons/CloIcon/CloIcon.vue';
Vue.component('CloIcon', CloIcon);

// local
import Test from './Test.vue'
Vue.component('Test', Test);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "locale",
  fallbackLocale: "locale",
  messages: {
    locale: window.langMap,
  },
});

window.addEventListener("DOMContentLoaded", function () {
  // initialize components on page load
  if (document.querySelector("[data-lichen-vue]")) {
    var els = document.querySelectorAll("[data-lichen-vue]");
    Array.prototype.forEach.call(els, function (el) {
      new Vue({ el, i18n });
    });
  }
});